import Typography from '@mui/material/Typography';

export default function TextLine({text, size}){
	const sizes = {"big":"h5", "medium":"h6", "small":"h7"};
	const variant = sizes[size] || "h6";
	return <Typography variant={variant} sx={{}}>{text}</Typography>
}